import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import MuiDenseTable from "../../../common-utilities/core/mui-dense-table";
import {REPORT_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/pl-report";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { toast } from "react-toastify";
import { getSalesHeader } from "./helper";

const SalesSummary = ({
  tabIndex,
  filters,
  dateRanges,
  slug,
  token,
  searchTrigger,
  setSearchTrigger,
}) => {
  const [data, setData] = useState({});
  const loadData = () => {
    let params = {};
    let payload = {
      viewFilters: {},
    };

    if (dateRanges?.startMonth && dateRanges?.startYear) {
      params.date = `${dateRanges?.startMonth}/01/${dateRanges?.startYear}`;
    }

    (filters.selectedFilters || []).forEach((filter) => {
      
      if (Array.isArray(filter.value) && filter.value.length > 0) {
        payload[filter.id] = filter.value.map((v) => v.value ?? v);
      }
    });

    if (filters?.scope?.find((f) => f.id === "All India")) {
      payload.viewFilters["All India"] = ["All India"];
    }

    if (filters?.circles?.length > 0) {
      payload.viewFilters["circles"] = filters.circles.map((v) => v.value ?? v);
    }
    if (filters?.regions?.length > 0) {
      payload.viewFilters["regions"] = filters?.regions.map(
        (v) => v.value ?? v
      );
    }

    if (filters?.scope?.length === 0) {
      delete payload.viewFilters;
    }

    if (Object.keys(filters.selectScopeValues).length > 0) {
      Object.keys(filters.selectScopeValues).forEach((key) => {
        payload[key?.toLowerCase()] = filters.selectScopeValues[key].map(
          (v) => v.value ?? v
        );
      });
    }

    if (filters?.scopeValues?.["Store Opening Date"]) {
      payload.storeOpeningDate = filters.scopeValues["Store Opening Date"];
    }

    if (filters?.cohortTypes.length > 0) {
      payload["cohortTypes"] = filters?.cohortTypes.map((v) => v.value ?? v);
    }

        if (filters?.metric.length > 0) {
      payload["metric"] = filters?.metric.map((v) => v.value ?? v);
    }
    

    invokeApi(
      HTTP_METHODS.POST,
      `${REPORT_HOSTNAME}${REST_URLS.SALES_SUMMARY}`,
      payload,
      params,
      null,
      slug,
      token
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          setData(response);
        }
      })
      .catch((err) => {});
    if (searchTrigger) {
      setSearchTrigger(false);
    }
  };

  useEffect(() => {
    if (tabIndex === 0) {
      loadData();
    }
  }, [searchTrigger]);

  return (
    <Box sx={{ p: 2 }}>
      {Object.keys(data).length > 0 ? (
        Object.keys(data)?.map((region, index) => {
          const dataList = data[region]?.map((row) => {
            const flatRow = { ...row, showNow: true };

            ["MTD", "QTD", "YTD"].forEach((group) => {
              if (row[group] && Array.isArray(row[group])) {
                row[group].forEach((item) => {
                  flatRow[`${group}-${item.key}`] = item.value;
                });
              }
            });

            return flatRow;
          });

          const columnsList = getSalesHeader(data[region], region);

          return (
            <Box key={index} sx={{ mb: 5 }}>
              <MuiDenseTable dataList={dataList} columnsList={columnsList} firstColumn="scope" />
            </Box>
          );
        })
      ) : (
        <Typography variant="h4" textAlign="center" mt={5}>
          No data found
        </Typography>
      )}
    </Box>
  );
};

export default SalesSummary;
